export default "__VITE_ASSET__BCP$Q10___"